import * as React from 'react'

import {
  City,
  FirstName,
  FormGroup,
  LastName,
  PostalCode,
  Street,
  Text,
  Util,
} from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

import { isPostalCode } from '../../../util/form-validation'
import { FormProps } from '../types'

const AddressForm: React.FC<FormProps> = () => {
  const { getLabel } = useIntl()

  return (
    <React.Fragment>
      <FormGroup columns={2}>
        <FirstName
          label={getLabel('checkout.contact.firstName')}
          errorMessage={getLabel('checkout.contact.firstName.errorMessage')}
          validations={[Util.validations.isText, Util.validations.maxLength(40)]}
          maxLength={40}
        />
        <LastName
          label={getLabel('checkout.contact.lastName')}
          errorMessage={getLabel('checkout.contact.lastName.errorMessage')}
          validations={[Util.validations.isText, Util.validations.maxLength(40)]}
          maxLength={40}
        />
      </FormGroup>
      <FormGroup>
        <Text
          id="additionalAddressInfo"
          data-t="additionalAddressInfo"
          required={false}
          label={getLabel('checkout.contact.careOf')}
          errorMessage={getLabel('checkout.contact.careOf.errorMessage')}
          validations={[Util.validations.maxLength(40)]}
          optionalText={getLabel('checkout.form.field.optional')}
          maxLength={40}
        />
      </FormGroup>
      <FormGroup>
        <Street
          label={getLabel('checkout.address.street')}
          errorMessage={getLabel('checkout.address.street.errorMessage')}
          validations={[Util.validations.maxLength(40)]}
          maxLength={40}
        />
      </FormGroup>
      <FormGroup columns={2}>
        <PostalCode
          label={getLabel('checkout.address.postalCode')}
          validations={[isPostalCode]}
          errorMessage={getLabel('checkout.address.postalCode.errorMessage')}
        />
        <City
          label={getLabel('checkout.address.city')}
          errorMessage={getLabel('checkout.address.city.errorMessage')}
          validations={[Util.validations.isText, Util.validations.maxLength(30)]}
          maxLength={30}
        />
      </FormGroup>
    </React.Fragment>
  )
}
export const CheckoutAddressForm = () => <AddressForm />
export default AddressForm
